// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react"

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"))
  const [user, setUser] = useState(null) // start with no user
  const [backOffice, setBackOffice] = useState(false) // start with no user

  useEffect(() => {
    const storedToken = localStorage.getItem("authToken")
    if (storedToken !== authToken) {
      setAuthToken(storedToken)
    }
  }, [])

  const updateToken = (token, userData = null, back_office = null, continueSession, navigate) => {
    if (token) {
      localStorage.setItem("authToken", token)
      setAuthToken(token)
      if (userData) {
        setUser(userData)
      }
      if (back_office?.toString() === "true" || back_office?.toString() === "false") {
        setBackOffice(back_office)
      }

      if (continueSession) {
        checkNavigation(navigate, userData, back_office)
      }
    } else {
      localStorage.removeItem("authToken")
      setAuthToken(null)
      setUser(null)
      setBackOffice(null)
    }
  }

  const checkNavigation = (navigate, userData = user, back_office = backOffice) => {
    const current_url = window.location.pathname // e.g., '/admin/settings'
    const currentPath = current_url.split("/")[1]
    // console.log("current_url", current_url);
    // console.log("currentPath", currentPath);

    // console.log("user", user);

    const roleId = userData?.userRoleId?.toString()
    const redirectMap = {
      1: "/super-admin",
      2: "/admin",
      3: "/user",
      4: "/admin",
    }

    const clientRedirectMap = {
      2: "/client",
      3: "/employee",
    }
    const backOfficeRedirect = () => {
      if (redirectMap[roleId]) {
        navigate(redirectMap[roleId])
      } else {
        navigate("/back-office-unknown")
      }
    }

    const clientRedirect = () => {
      if (clientRedirectMap[roleId]) {
        navigate(clientRedirectMap[roleId])
      } else {
        navigate("/back-office-unknown")
      }
    }

    if (current_url === "/login" || current_url === "/") {
      if (back_office) {
        backOfficeRedirect()
      } else {
        clientRedirect()
      }
    } else if (["admin", "user", "client", "employee"].includes(currentPath)) {
      if (back_office) {
        // Allow access only if current path matches role-based route
        if (redirectMap[roleId] === `/${currentPath}`) {
          // Allowed, do nothing
        } else {
          backOfficeRedirect()
        }
      } else {
        if (clientRedirectMap[roleId] === `/${currentPath}`) {
          // Allowed, do nothing
        } else {
          clientRedirect()
        }
      }
    } else {
      navigate("/not-found")
    }
  }

  return <AuthContext.Provider value={{ authToken, setAuthToken: updateToken, user, backOffice }}>{children}</AuthContext.Provider>
}

// Custom hook
export const useAuth = () => useContext(AuthContext)
